import { render } from "./ChatsTransferView.vue?vue&type=template&id=733663c0&ts=true"
import script from "./ChatsTransferView.vue?vue&type=script&lang=ts"
export * from "./ChatsTransferView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__